import Typography from '@mui/material/Typography';
import { useMatchRouteMeta } from 'src/router';

type Params = {
  subtitle?: string | undefined;
};

function PageTitle({ subtitle }: Params) {
  const { title } = useMatchRouteMeta(true);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '10px',
      }}
    >
      <Typography marginY={2} variant="h1">
        {title}
      </Typography>
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
    </div>
  );
}

export default PageTitle;
